export default "__VITE_ASSET__CkbYzdYu__"